import { render } from "./triage.vue?vue&type=template&id=0cf1d225&scoped=true"
import script from "./triage.vue?vue&type=script&lang=js"
export * from "./triage.vue?vue&type=script&lang=js"

import "./triage.vue?vue&type=style&index=0&id=0cf1d225&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf1d225"]])

export default __exports__